import { useEffect, useState } from 'react';
import { collection, limit, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../utils/firebase';
import {
  parseDeliveryLogDoc,
  type NotificationDeliveryLogEntry,
} from '../utils/notificationDeliveryLog';

const FEED_LIMIT = 250;

export function useNotificationDeliveryFeed(enabled: boolean) {
  const [entries, setEntries] = useState<NotificationDeliveryLogEntry[]>([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      setEntries([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    const q = query(
      collection(db, 'notificationDeliveryLog'),
      orderBy('createdAt', 'desc'),
      limit(FEED_LIMIT),
    );

    const unsubscribe = onSnapshot(
      q,
      (snap) => {
        setEntries(snap.docs.map((docSnap) => parseDeliveryLogDoc(docSnap.id, docSnap.data())));
        setLoading(false);
      },
      (err) => {
        console.error('[useNotificationDeliveryFeed]', err);
        setError(err.message || 'Could not load delivery feed');
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, [enabled]);

  return { entries, loading, error };
}
